import CalendarViewMonthIcon from "@mui/icons-material/CalendarViewMonth";

import SatCurve from "@/Components/Icons/SatCurve";
import { ToggleButton } from "@/Components/v2/atoms/Button";
import { ToggleButtonGroup } from "@/Components/v2/molecule/ButtonGroup/";

import {
  SaturationCurvesView,
  useInvestmentLevelsStore,
} from "../../store/useInvestmentLevelsStore";

const SaturationCurvesViewSelector = () => {
  const saturationCurvesView = useInvestmentLevelsStore((state) => state.saturationCurvesView);
  const { setSaturationCurvesView } = useInvestmentLevelsStore();

  const handleChange = (_: React.MouseEvent<HTMLElement>, newValue: SaturationCurvesView) => {
    setSaturationCurvesView(newValue);
  };

  const isSelected = (view: SaturationCurvesView) => saturationCurvesView === view;

  const options = [
    {
      value: SaturationCurvesView.TABLE,
      icon: <CalendarViewMonthIcon sx={{ transform: "rotate(90deg)" }} />,
    },
    {
      value: SaturationCurvesView.CURVES,
      icon: <SatCurve isSelected={isSelected(SaturationCurvesView.CURVES)} />,
    },
  ];

  return (
    <ToggleButtonGroup
      value={saturationCurvesView}
      exclusive
      onChange={handleChange}
      sx={{
        width: "120px",
      }}
    >
      {options.map((option) => (
        <ToggleButton key={option.value} value={option.value}>
          {option.icon}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
};

export default SaturationCurvesViewSelector;
